package shared.ui.components

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import AppState
import Router
import features.auth.handlers.handleLogout

object Navbar {
    fun render(parent: DIV, title: String, showBackButton: Boolean) {
        parent.nav("bg-dark-800 border-b border-dark-700 sticky top-0 z-50") {
            div("max-w-7xl mx-auto px-4 py-4 flex justify-between items-center") {
                div("flex items-center gap-3") {
                    if (showBackButton) {
                        button(classes = "w-8 h-8 rounded-full bg-dark-700 hover:bg-slate-600 flex items-center justify-center transition") {
                            onClickFunction = { Router.navigateTo("dashboard") }
                            +"←"
                        }
                    }
                    img(src = "logo.png", alt = "Logo") {
                        classes = setOf("w-8", "h-8", "drop-shadow-[0_0_8px_rgba(6,182,212,0.5)]")
                    }
                    span("text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-brand-cyan to-brand-teal") {
                        +title
                    }
                }
                div("flex items-center gap-3") {
                    // Notification Bell
                    features.notifications.ui.components.NotificationBell.render(this)
                    
                    AppState.currentUser?.let { user ->
                        img(src = user.avatar) {
                            classes = setOf("w-10", "h-10", "rounded-full", "border-2", "border-brand-cyan")
                        }
                        span("font-medium hidden sm:inline") { +user.name }
                        button(classes = "px-3 py-1.5 rounded-lg bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/30 transition text-sm font-medium") {
                            onClickFunction = { handleLogout() }
                            +"Logout"
                        }
                    }
                }
            }
        }
    }
}
